
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 121.807 121.807"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.308 75.519A7.306 7.306 0 000 82.827a7.31 7.31 0 007.308 7.31h18.897l-3.496 3.495a7.308 7.308 0 0010.334 10.339l13.833-13.834h67.621a7.31 7.31 0 100-14.619H61.495L80.982 56.03h33.515a7.31 7.31 0 100-14.617H95.602l13.24-13.24a7.309 7.309 0 00-10.334-10.336L74.932 41.414H7.308A7.307 7.307 0 000 48.723a7.307 7.307 0 007.308 7.308H60.31L40.821 75.519H7.308z"}})])
          )
        }
      }
    